import React from 'react';
import { Tag, Space, Button } from 'antd';
import { 
  LinkOutlined, 
  DisconnectOutlined, 
  SyncOutlined 
} from '@ant-design/icons';

// Define WebSocket connection states
export type ConnectionStatus = 'disconnected' | 'connecting' | 'connected' | 'reconnecting' | 'error';

interface ConnectionStatusProps {
  status: ConnectionStatus;
  onReconnect: () => void;
}

const ConnectionStatusComponent: React.FC<ConnectionStatusProps> = ({ status, onReconnect }) => {
  switch (status) {
    case 'connected':
      return <Tag icon={<LinkOutlined />} color="success">Connected</Tag>;
    
    case 'connecting':
      return <Tag icon={<SyncOutlined spin />} color="processing">Connecting...</Tag>;
    
    case 'reconnecting':
      return (
        <Space>
          <Tag icon={<SyncOutlined spin />} color="warning">Reconnecting...</Tag>
          <Button type="text" size="small" icon={<SyncOutlined />} onClick={onReconnect} />
        </Space>
      );
    
    case 'error':
      return (
        <Space>
          <Tag icon={<DisconnectOutlined />} color="error">Connection Error</Tag>
          <Button type="text" size="small" icon={<SyncOutlined />} onClick={onReconnect} />
        </Space>
      );
    
    default:
      return (
        <Space>
          <Tag icon={<DisconnectOutlined />} color="default">Disconnected</Tag>
          <Button type="text" size="small" icon={<SyncOutlined />} onClick={onReconnect} />
        </Space>
      );
  }
};

export default ConnectionStatusComponent; 